/**
 * @desc create
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanCreateRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlan/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
